import { render, staticRenderFns } from "./FiltersBatchReview.vue?vue&type=template&id=08ca9f43"
import script from "./FiltersBatchReview.vue?vue&type=script&lang=js"
export * from "./FiltersBatchReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports